import { isFetchBaseQueryError } from 'utils/erros';

export const isPDPPermissionError = (error: unknown): boolean =>
    isFetchBaseQueryError(error) && error.status === 403;